"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.BrandMomentCaptureIntro = void 0;
var react_1 = __importDefault(require("react"));
var Base_1 = require("./Base");
var VideoPlayer_1 = require("./Players/VideoPlayer");
/**
 * This component is a snowflake. It plays two assets one after the other:
 *  - An "initial" animation that is only ever played once, never looping
 *  - An "ambient" animation that can be looped, depending on the props passed into it
 */
var BrandMomentCaptureIntro = function (_a) {
    var isAnimated = _a.isAnimated, alt = _a.alt, enableAspectRatio = _a.enableAspectRatio, otherProps = __rest(_a, ["isAnimated", "alt", "enableAspectRatio"]);
    var _b = react_1["default"].useState(false), firstAnimationComplete = _b[0], setFirstAnimationComplete = _b[1];
    if (isAnimated) {
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement("div", { style: { display: firstAnimationComplete ? "none" : "" } },
                react_1["default"].createElement(VideoPlayer_1.VideoPlayer, __assign({}, otherProps, { aspectRatio: enableAspectRatio ? "landscape" : undefined, fallback: "illustrations/heart/scene/brand-moments-capture-intro", source: "illustrations/heart/scene/brand-moments-capture-intro", onEnded: function () { return setFirstAnimationComplete(true); }, loop: false }))),
            react_1["default"].createElement("div", { style: { display: firstAnimationComplete ? "" : "none" } },
                react_1["default"].createElement(VideoPlayer_1.VideoPlayer, __assign({}, otherProps, { aspectRatio: enableAspectRatio ? "landscape" : undefined, fallback: "illustrations/heart/scene/brand-moments-capture-intro-loop", source: "illustrations/heart/scene/brand-moments-capture-intro-loop", autoplay: firstAnimationComplete ? otherProps.autoplay : false })))));
    }
    return (react_1["default"].createElement(Base_1.Base, __assign({ aspectRatio: enableAspectRatio ? "landscape" : undefined, alt: alt || "" }, otherProps, { name: "illustrations/heart/scene/brand-moments-capture-intro-loop.png" })));
};
exports.BrandMomentCaptureIntro = BrandMomentCaptureIntro;
exports.BrandMomentCaptureIntro.displayName = "BrandMomentCaptureIntro";
//# sourceMappingURL=BrandMomentCaptureIntro.js.map